// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"b4327338","390":"b4327338","462":"b4327338","578":"b4327338","671":"b4327338","789":"b4327338","909":"b4327338"}[chunkId] + ".chunk.css";
};